module.exports = __webpack_public_path__ + "static/media/people-2.8bb1c1e5.jpg";